import { Footer } from "antd/es/layout/layout";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import NavBar from "../../../components/NavBar";
import SideBar from "../../../components/SideBar";
import { LOGGED_USER } from "../../../variables/constants";
import Details from "./tabsContent/Details";
import Recours from "./tabsContent/Recours";
import Traitements from "./tabsContent/Traitements";
import axiosInstance from "../../../variables/api/axiosInstance";
import { searchSinistre } from "../../../hooks/useSearch";
import { highlightMatch } from "../../../variables/stringFunctions";
import { frenchDate } from "../../../variables/functions";

const initEvaluation = {
    ancienneProvision: 0, nouvelleProvision: 0, motifRevision: null, reviseur: "", sinistre: "", provisionGaranties: [],
};

const initVictime = {
    descriptionDegatsVictime: "", sinistre: "", personne: {
        nom: "", prenom: "", adresse: "", profession: "", temoin: true,
    },
};

const DetailsSinistre = () => {
    const param = useParams()
    const navigate = useNavigate()
    const location = useLocation();
    const data = location?.state;
    const codeId = data.codeId;
    const [sinistre, setSinistre] = useState();
    const [captures, setCaptures] = useState([]);
    const [captured, setCaptured] = useState([]);
    const [modalReevaluation, setModalReevaluation] = useState(false);
    const [modalRecoursReevaluation, setModalRecoursReevaluation] = useState(false);
    const [modalVictime, setModalVictime] = useState(false);
    // const [tabId, setTabId] = useState("1");
    const [evaluation, setEvaluation] = useState(initEvaluation);
    const [editMode, setEditMode] = useState(false);
    const [evaluations, setEvaluations] = useState([]);
    const [recoursEvaluations, setRecoursEvaluations] = useState([]);
    const [victime, setVictime] = useState(initVictime);
    const [victimes, setVictimes] = useState([]);
    const [modalReglementSinistre, setModalReglementSinistre] = useState(false);
    const [modalEncaissement, setModalEncaissement] = useState(false);
    const [modalAddExpert, setModalAddExpert] = useState(false);
    const [searchResults, setSearchResults] = useState([]);
    const [searchValue, setSearchValue] = useState("");

    const [garanties, setGaranties] = useState([]);
    const [selectedGaranties, setSelectedGaranties] = useState([]);
    const [garantieState, setGarantieState] = useState("");
    const [valueSelected, setValueSelected] = useState([]);
    const [provisionGaranties, setProvisionGarantie] = useState([]);
    const [decaissements, setDecaissements] = useState([]);
    const [encaissements, setEncaissements] = useState([]);

    const [ordreDepense, setOrdreDepense] = useState("");
    const [modalOrdreDepense, setModalOrdreDepense] = useState(false);

    const [ficheDemandeReglement, setFicheDemandeReglement] = useState("");
    const [modalFicheDemandeReglement, setModalFicheDemandeReglement] = useState(false);
    const [modalAssignCheque, setModalAssignCheque] = useState(false);
    const [decaissement, setDecaissement] = useState();
    const [experts, setExperts] = useState([]);
    const [expertises, setExpertises] = useState([]);
    const [modalCloture, setModalCloture] = useState(false);
    const [modalSuspension, setModalSuspension] = useState(false);
    const [loadingCloture, setLoadingCloture] = useState(false);
    const [loadingSuspension, setLoadingSuspension] = useState(false);
    const [loadingSinistre, setLoadingSinistre] = useState(false)
    const [items, setItems] = useState(["Nouvelles investigations", "Imprévus", "Clôture", "Nouveau élément dans le dossier", "Forclusion", "Provision insuffisante", "Inventaire",]);

    const [activeTab, setActiveTab] = useState('details')
    const [refetch, setRefetch] = useState(false)
    // States for evaluation
    const [motifRevisionState, setMotifRevisionState] = useState("");
    // State for victimes
    const [nomState, setNomState] = useState("");
    const [prenomState, setPrenomState] = useState("");
    const [adresseState, setAdresseState] = useState("");
    const [professionState, setProfessionState] = useState("");
    const [descriptionDegatsVictimeState, setDescriptionDegatsVictimeState,] = useState("");
    const [isRecours, setIsRecours] = useState(false);
    const showQuittance = (item) => {
        setQuittance(item);
        setModalQuittance(true);
    };

    const [quittance, setQuittance] = useState();
    const [modalQuittance, setModalQuittance] = useState(false);
    const [montant, setMontant] = useState(0);
    const [montantPaye, setMontantPaye] = useState(0);

    useEffect(() => {
        if (codeId) {
            setLoadingSinistre(true)
            axiosInstance
                .get(`/api/sinistre/codeId/${codeId}`)
                .then((res) => {
                    setSinistre(res.data);
                    setEvaluations(res.data?.evaluations?.filter((d) => d.encaissement === false || d.encaissement === null));
                    setRecoursEvaluations(res.data?.evaluations?.filter((d) => d.recours === true));
                    setVictimes(res.data?.victimes);
                    setDecaissements(res.data?.decaissements?.filter((d) => d.encaissement === false || d.encaissement === null)
                        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                    );
                    setEncaissements(res.data?.decaissements?.filter((d) => d.encaissement === true)
                        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                    );
                    setExperts(res.data?.experts);
                    let m = 0.0;
                    let mt = 0.0;
                    let tempDecaissements = res.data?.decaissements;
                    tempDecaissements = tempDecaissements?.filter((d) => (d.etatDecaissement === 'ENCAISSE' || d.etatDecaissement === 'VALIDE' || d.etatDecaissement === 'EN_ATTENTE_D_ENCAISSEMENT'));
                    tempDecaissements?.forEach((d) => {
                        if (!d.encaissement) {
                            m += parseFloat(d.montantGlobal);
                            if (d.etatDecaissement === 'ENCAISSE') {
                                mt += parseFloat(d.montantGlobal);
                            }
                        }
                    });
                    setMontant(m);
                    setMontantPaye(mt);

                    if (res.data?.engin) {
                        axiosInstance
                            .get(`/api/garantie/categorie/compulsory/code/${res.data?.engin?.categorie?.codeCategorie}`)
                            .then((response) => {
                                let gs = [];
                                gs = response.data;
                                let g = [];
                                res.data?.engin?.sousGaranties && res.data?.engin?.sousGaranties?.forEach((sg) => {
                                    gs.push(sg.garantie);
                                    g.push({
                                        value: sg.garantie.codeId, label: sg.nom, garantie: sg.garantie,
                                    });
                                });

                                response?.data && response?.data?.forEach((ga) => {
                                    g.push({
                                        value: ga.codeId, label: ga.nom, garantie: ga,
                                    });
                                });
                                setGaranties(g);
                            })
                            .catch((err) => {
                                console.log(err);
                            });
                    }
                    if (res.data?.captures) {
                        setCaptures(res.data?.captures);
                        axiosInstance
                            .get(`/api/sinistre/captures/${res.data.codeId}`)
                            .then((resp) => {
                                // console.log("resssss", res.data);
                                // setCaptures(res.data);
                                let cpt = [];
                                resp.data?.forEach((c) => {
                                    cpt.push({
                                        uid: c.captureId,
                                        name: c.nom,
                                        status: "done",
                                        url: `data:image/png;base64,${c}`,
                                    });
                                });
                                setCaptured(cpt);
                            })
                            .catch((err) => {
                                console.log(err);
                            });
                        setLoadingSinistre(false)
                    }
                })
                .catch((err) => {
                    setLoadingSinistre(false)
                    console.log(err);
                });

            axiosInstance.get(`/api/expertise/sinistre/${codeId}`)
                .then((res) => {
                    console.log(res.data);
                    setExpertises(res.data);
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }, [param, refetch, codeId]);
    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    const handleDecaissementAfterUpdate = (updatedDecaissement) => {
        if (!updatedDecaissement || !updatedDecaissement.codeId) {
            return;
        }

        setDecaissements((previous) =>
            Array.isArray(previous)
                ? previous?.map((item) =>
                    item.codeId === updatedDecaissement.codeId
                        ? { ...item, ...updatedDecaissement }
                        : item
                )
                : previous
        );

        setEncaissements((previous) =>
            Array.isArray(previous)
                ? previous?.map((item) =>
                    item.codeId === updatedDecaissement.codeId
                        ? { ...item, ...updatedDecaissement }
                        : item
                )
                : previous
        );

        setSinistre((previous) => {
            if (!previous || !Array.isArray(previous?.decaissements)) {
                return previous;
            }
            const decaissementsMaj = previous?.decaissements?.map((item) =>
                item.codeId === updatedDecaissement.codeId
                    ? { ...item, ...updatedDecaissement }
                    : item
            );
            return {
                ...previous,
                decaissements: decaissementsMaj,
            };
        });
    };
    const isValidated = () => {
        if (motifRevisionState === "success" && garantieState === "success") {
            return true;
        } else {
            if (motifRevisionState !== "success") {
                return false;
            }
            if (garantieState !== "success") {
                return false;
            }
        }
    };

    const handleSubmit = (e, rec) => {
        e.preventDefault();
        const validate = isValidated();
        if (validate) {
            if (editMode) {
                evaluation.sinistre = sinistre;
                evaluation.reviseur = LOGGED_USER;
                evaluation.ancienneProvision = sinistre?.evaluation;
                evaluation.encaissement = isRecours;
                evaluation.encaissement = rec;
                axiosInstance
                    .post(`/api/provision-garantie/all`, JSON.stringify(provisionGaranties))
                    .then((response) => {
                        console.log(response.data);
                        evaluation.provisionGaranties = response.data;
                        axiosInstance
                            .put(`/api/evaluation`, JSON.stringify(evaluation))
                            .then((res) => {
                                console.log(res.data);
                                setEditMode(false);
                                setModalReevaluation(false);
                                setEvaluation(initEvaluation);
                                toast("Mis à jour");
                            })
                            .catch((err) => {
                                console.log(err);

                            });
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            } else {
                evaluation.sinistre = sinistre;
                evaluation.reviseur = LOGGED_USER;
                evaluation.ancienneProvision = sinistre?.evaluation;
                evaluation.encaissement = isRecours;
                evaluation.encaissement = rec;
                axiosInstance
                    .post(`/api/provision-garantie/all`, JSON.stringify(provisionGaranties))
                    .then((response) => {
                        console.log(response.data);
                        evaluation.provisionGaranties = response.data;
                        console.log("evaluation", evaluation);
                        axiosInstance
                            .post(`/api/evaluation`, JSON.stringify(evaluation))
                            .then((res) => {
                                console.log(res.data);
                                setModalReevaluation(false);
                                setModalRecoursReevaluation(false);
                                setEvaluation(initEvaluation);
                                toast("créée");
                            })
                            .catch((err) => {
                                console.log(err);

                            });
                    })
                    .catch((err) => {

                        console.log(err);
                    });
            }
        } else {
            toast("Vérifier vos entrées");
        }
    };
    const handleChange = (e, nom) => {
        if (nom) {
            setEvaluation({ ...evaluation, [nom]: e });
        } else {
            const { name, value } = e.target;
            setEvaluation({ ...evaluation, [name]: value });
        }
    };

    const [name, setName] = useState("");
    const inputRef = useRef(null);
    const setOpenReglement = (value) => {
        setModalReglementSinistre(value);
    };
    const handleSuspensionDossier = () => {
        setLoadingSuspension(true);
        axiosInstance
            .get(`/api/sinistre/suspension/${sinistre.codeId}`)
            .then((res) => {
                // console.log(res.data);
                setLoadingSuspension(false);
                setModalSuspension(false);
                toast.success(sinistre?.sortDossier === "S" ? "Dossier réactivé avec succès!" : "Dossier suspendu avec succès!");
                navigate(`/details-sinistre`, {
                    state: { codeId: res.data.codeId }
                });
            })
            .catch((err) => {
                console.log(err);
                setLoadingSuspension(false);
                setModalSuspension(false);
                toast.error(sinistre?.sortDossier === "S" ? "Échec lors de la reouverture du dossier!" : "Échec lors de la suspension du dossier!");
            });
    };
    const addItem = (e) => {
        e.preventDefault();
        setItems([...items, name || `New item ${items.length + 1} `]);
        setName("");
        setTimeout(() => {
            inputRef.current?.focus();
        }, 0);
    };

    const handleClotureDossier = () => {
        setLoadingCloture(true);
        axiosInstance
            .get(`/api/sinistre/cloture/${sinistre.codeId}`)
            .then((res) => {
                // console.log(res.data);
                setLoadingCloture(false);
                setModalCloture(false);
                toast.success("Dossier clôturé avec succès");
                navigate(`/details-sinistre`, {
                    state: { codeId: res.data.codeId }
                });
            })
            .catch((err) => {
                console.log(err);
                setLoadingCloture(false);
                setModalCloture(false);
                toast.error("Échec lors de la clôture du dossier");
            });
    };
    const onNameChange = (event) => {
        setName(event.target.value);
    };

    const showOrdreDepense = (item) => {
        setOrdreDepense(item);
        setModalOrdreDepense(true);
    };

    const editEvaluation = (item) => {
        setEditMode(true);
        setEvaluation(item);
        setProvisionGarantie(item.provisionGaranties);
        const pg = [];
        const pgi = [];
        item.provisionGaranties?.forEach((p) => {
            pg.push(p.garantie);
            pgi.push(p.garantie.codeId);
        });
        setValueSelected(pgi);
        setSelectedGaranties(pg);
        setMotifRevisionState("success");
        setGarantieState("success");
        setModalReevaluation(true);
    };
    const setOpenEncaissement = (value) => {
        setModalEncaissement(value);
    };

    const renderContent = () => {
        if (activeTab === 'details') {
            return (<Details montant={montant} montantPaye={montantPaye} setModalFicheDemandeReglement={setModalFicheDemandeReglement}
                setFicheDemandeReglement={setFicheDemandeReglement} captured={captured} captures={captures}
                initEvaluation={initEvaluation} setModalSuspension={setModalSuspension}
                setModalCloture={setModalCloture}
                decaissements={decaissements} evaluations={evaluations} experts={experts} expertises={expertises} items={items}
                handleSubmit={handleSubmit} modalQuittance={modalQuittance}
                setDecaissement={setDecaissement} setEvaluation={setEvaluations} sinistre={sinistre}
                onSinistreUpdate={setSinistre}
                valueSelected={valueSelected}
                quittance={quittance} setQuittance={setQuittance} setAdresseState={setAdresseState}
                inputRef={inputRef} handleClotureDossier={handleClotureDossier}
                handleSuspensionDossier={handleSuspensionDossier}
                setDescriptionDegatsVictimeState={setDescriptionDegatsVictimeState}
                loadingCloture={loadingCloture} loadingSuspension={loadingSuspension}
                onNameChange={onNameChange} modalAssignCheque={modalAssignCheque}
                modalCloture={modalCloture} modalSuspension={modalSuspension}
                setGarantieState={setGarantieState} victimes={victimes} loadingSinistre={loadingSinistre}
                garanties={garanties} ordreDepense={ordreDepense}
                setModalAssignCheque={setModalAssignCheque} setModalOrdreDepense={setModalOrdreDepense}
                editMode={editMode}
                setModalQuittance={setModalQuittance} setModalReevaluation={setModalReevaluation}
                handleChange={handleChange} ficheDemandeReglement={ficheDemandeReglement}
                setModalVictime={setModalVictime} setOrdreDepense={setOrdreDepense}
                provisionGaranties={provisionGaranties}
                setMotifRevisionState={setMotifRevisionState} setNomState={setNomState} addItem={addItem}
                modalReevaluation={modalReevaluation} refetch={refetch} setRefetch={setRefetch}
                modalFicheDemandeReglement={modalFicheDemandeReglement} decaissement={decaissement}
                setPrenomState={setPrenomState} setProfessionState={setProfessionState}
                setVictime={setVictime} editEvaluation={editEvaluation} name={name}
                selectedGaranties={selectedGaranties} evaluation={evaluation}
                setProvisionGarantie={setProvisionGarantie} setSelectedGaranties={setSelectedGaranties}
                setValueSelected={setValueSelected}
                onDecaissementUpdated={handleDecaissementAfterUpdate}
                setEditMode={setEditMode} />)
        } else if (activeTab === 'traitements') {
            return (<Traitements setModalFicheDemandeReglement={setModalFicheDemandeReglement}
                setFicheDemandeReglement={setFicheDemandeReglement} modalSuspension={modalSuspension}
                loadingSuspension={loadingSuspension}
                loadingCloture={loadingCloture} handleClotureDossier={handleClotureDossier}
                handleSuspensionDossier={handleSuspensionDossier} modalCloture={modalCloture}
                captures={captures} modalAddExpert={modalAddExpert}
                decaissements={decaissements} evaluations={evaluations} experts={experts} expertises={expertises}
                setDecaissement={setDecaissement} setEvaluation={setEvaluations} sinistre={sinistre}
                quittance={quittance} setAdresseState={setAdresseState}
                setDescriptionDegatsVictimeState={setDescriptionDegatsVictimeState}
                setGarantieState={setGarantieState} victimes={victimes}
                loadingSinistre={loadingSinistre}
                setModalAssignCheque={setModalAssignCheque} setModalOrdreDepense={setOrdreDepense}
                setModalQuittance={setModalQuittance} setModalReevaluation={setModalReevaluation}
                setModalVictime={setModalVictime} setOrdreDepense={setOrdreDepense}
                setMotifRevisionState={setMotifRevisionState} setNomState={setNomState}
                setPrenomState={setPrenomState} setProfessionState={setProfessionState}
                setVictime={setVictime} provisionGaranties={provisionGaranties}
                modalReglementSinistre={modalReglementSinistre}
                setProvisionGarantie={setProvisionGarantie} setSelectedGaranties={setSelectedGaranties}
                setValueSelected={setValueSelected} setModalAddExpert={setModalAddExpert}
                setRefetch={setRefetch}
                setOpenReglement={setOpenReglement}
                setEditMode={setEditMode} setModalSuspension={setModalSuspension}
                inputRef={inputRef} valueSelected={valueSelected} selectedGaranties={selectedGaranties}
                decaissement={decaissement} victime={victime} initEvaluation={initEvaluation}
                items={items} handleSubmit={handleSubmit} ordreDepense={ordreDepense}
                professionState={professionState}
                setItems={setItems} editMode={editMode} evaluation={evaluation} setName={setName}
                setModalReglementSinistre={setModalReglementSinistre} setModalCloture={setModalCloture}
                prenomState={prenomState} modalVictime={modalVictime} modalQuittance={modalQuittance}
                modalReevaluation={modalReevaluation} handleChange={handleChange}
                modalAssignCheque={modalAssignCheque} modalOrdreDepense={modalOrdreDepense}
                descriptionDegatsVictimeState={descriptionDegatsVictimeState} nomState={nomState}
                garanties={garanties}
                adresseState={adresseState} name={name} ficheDemandeReglement={ficheDemandeReglement}
                modalFicheDemandeReglement={modalFicheDemandeReglement}
                initVictime={initVictime} />)
        } else if (activeTab === 'recours') {
            return (
                <Recours evaluation={evaluation} sinistre={sinistre} selectedGaranties={selectedGaranties}
                    handleSuspensionDossier={handleSuspensionDossier} setIsRecours={setIsRecours} addItem={addItem}
                    encaissements={encaissements} handleClotureDossier={handleClotureDossier}
                    loadingCloture={loadingCloture} loadingSuspension={loadingSuspension}
                    modalCloture={modalCloture} modalEncaissement={modalEncaissement}
                    modalRecoursReevaluation={modalRecoursReevaluation} modalSuspension={modalSuspension}
                    onNameChange={onNameChange} setModalEncaissement={setModalEncaissement}
                    setModalRecoursReevaluation={setModalRecoursReevaluation}
                    showFicheDemandeReglement={setFicheDemandeReglement} showOrdreDepense={showOrdreDepense}
                    showQuittance={showQuittance} provisionGaranties={provisionGaranties}
                    setModalAssignCheque={setModalAssignCheque} setEvaluation={setEvaluation} garanties={garanties}
                    setProvisionGarantie={setProvisionGarantie} setSelectedGaranties={setSelectedGaranties}
                    setValueSelected={setValueSelected} name={name} handleChange={handleChange}
                    handleSubmit={handleSubmit}
                    setModalCloture={setModalCloture}
                    editMode={editMode} initEvaluation={initEvaluation} items={items} valueSelected={valueSelected}
                    inputRef={inputRef} setModalSuspension={setModalSuspension} setGarantieState={setGarantieState}
                    setMotifRevisionState={setMotifRevisionState} setDecaissement={setDecaissements}
                    montant={montant} editEvaluation={editEvaluation} recoursEvaluations={recoursEvaluations}
                    setOpenEncaissement={setOpenEncaissement} loadingSinistre={loadingSinistre} />
            )
        }
    }

    const renderSearchResults = (results) => {
        return <div className="px-3 py-2">
            <h6 className="text-muted text-uppercase mb-2" >.</h6>
            {results?.map((item, index) => (
                <div
                    key={index}
                    onClick={() =>
                        navigate("/details-sinistre", {
                            state: { codeId: item.codeId },
                        })
                    }
                    className="dropdown-item d-flex align-items-center gap-2 py-1"
                    style={{ cursor: "pointer" }}
                >
                    <span className="text-truncate">
                        {[
                            (item?.numeroSinistreM || item?.numeroSinistreP || item?.numSinistre),
                            item?.numeroPoliceM
                                ? item?.numeroPoliceM
                                : item?.numeroPoliceP,
                            frenchDate(item?.dateSinistre),
                            item?.immatriculation,
                            item?.nom,
                            item?.prenom || "",
                        ]?.map((text, i) => (
                            <React.Fragment key={i}>
                                {i > 0 && " - "}
                                {highlightMatch(text?.toString(), searchValue)}
                            </React.Fragment>
                        ))}
                    </span>
                </div>
            ))}
        </div>;
    }

    useEffect(() => {
        if (searchValue && searchValue?.length > 2) {
            searchSinistre(searchValue).then((res) => {
                setSearchResults(res.data.content);
            }).catch((err) => {
                console.log(err);
            });
        }
    }, [searchValue]);
    return (<div className="layout-wrapper layout-content-navbar  ">
        <div className="layout-container">
            <SideBar currentMenu={'SINISTRES'} />

            {/* <!-- Layout container --> */}
            <div className="layout-page">
                <NavBar
                    filteredResults={searchResults}
                    setFilteredResults={setSearchResults}
                    renderSearchResults={renderSearchResults}
                    searchValue={searchValue}
                    setSearchValue={setSearchValue}
                />

                {/* <!-- Content wrapper --> */}
                <div className="content-wrapper">
                    {/* <!-- Content --> */}
                    <div className="container-xxl flex-grow-1 container-p-y">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="nav-align-top">
                                    <ul className="nav nav-pills mb-4 nav-fill" role="tablist">

                                        <li className="nav-item mb-1 mb-sm-0">
                                            <button
                                                type="button"
                                                className={`nav-link ${activeTab === "details" ? "active" : ""}`}
                                                role="tab"
                                                onClick={() => handleTabChange("details")}
                                            >
                                                <span className="d-none d-sm-block">
                                                    <i className="bx bx-sm bx-user me-1_5"></i>
                                                    Détails
                                                </span>
                                                <i className="bx bx-home bx-sm d-sm-none"></i>
                                            </button>
                                        </li>
                                        <li className="nav-item mb-1 mb-sm-0">
                                            <button
                                                type="button"
                                                className={`nav-link ${activeTab === "recours" ? "active" : ""}`}
                                                role="tab"
                                                onClick={() => handleTabChange("recours")}
                                            >
                                                <span className="d-none d-sm-block">
                                                    <i className="bx bx-sm bx-bell me-1_5"></i>
                                                    RECOURS
                                                </span>
                                                <i className="bx bx-home bx-sm d-sm-none"></i>
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        {renderContent()}

                    </div>

                    {/* <!-- / Content --> */}

                    {/* <!-- Footer --> */}
                    <Footer />
                    {/* <!-- / Footer --> */}

                    <div className="content-backdrop fade"></div>
                </div>
                {/* <!-- Content wrapper --> */}
            </div>
            {/* <!-- / Layout page --> */}
        </div>

        {/* <!-- Overlay --> */}
        <div className="layout-overlay layout-menu-toggle"></div>

        {/* <!-- Drag Target Area To SlideIn Menu On Small Screens --> */}
        <div className="drag-target"></div>
    </div>);
};

export default DetailsSinistre;
